module.exports = __webpack_public_path__ + "static/assets/baccf211a9d3610d8c020d21a4ce3573.svg";